/**
 * 协议库接口
 * **/

const protocolApi = {
  //获取协议库列表（无登录）
  GetProtocolList: "/ProProtocol/GetListNoSession",
  //协议下载（无登录）
  downloadProtocolList: "/ProProtocol/ProDownload",
  //协议列表查询
  GetListSelf: "/ProProtocol/GetListSelf",
  //协议上传
  ProUpload: "/ProProtocol/ProUpload",
};

export default protocolApi;
